// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "c215e9b55214d383" + ".css";
};